
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2f1a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2f1a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9Hlf4", function(module, exports) {
function $70f89b75e05f95c9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $70f89b75e05f95c9$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3cqEM", function(module, exports) {

var $U9JKo = parcelRequire("U9JKo");

var $60mHf = parcelRequire("60mHf");

var $eCGcL = parcelRequire("eCGcL");

var $cbVh4 = parcelRequire("cbVh4");
function $25472b8d0a8a2081$var$_toConsumableArray(r) {
    return $U9JKo(r) || $60mHf(r) || $eCGcL(r) || $cbVh4();
}
module.exports = $25472b8d0a8a2081$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("U9JKo", function(module, exports) {

var $k8uMw = parcelRequire("k8uMw");
function $0a8cc89d570ba202$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $k8uMw(r);
}
module.exports = $0a8cc89d570ba202$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("k8uMw", function(module, exports) {
function $ea8c6e9238b8031c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $ea8c6e9238b8031c$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("60mHf", function(module, exports) {
function $45f4593cfeda2a57$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $45f4593cfeda2a57$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eCGcL", function(module, exports) {

var $k8uMw = parcelRequire("k8uMw");
function $aa555a4df2201ec5$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $k8uMw(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $k8uMw(r, a) : void 0;
    }
}
module.exports = $aa555a4df2201ec5$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cbVh4", function(module, exports) {
function $8e02f0a04e7667b1$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $8e02f0a04e7667b1$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



var $9Hlf4 = parcelRequire("9Hlf4");
var $cf9d3f3d64706810$require$_interopRequireDefault = $9Hlf4.default;

var $cf9d3f3d64706810$var$_toConsumableArray2 = $cf9d3f3d64706810$require$_interopRequireDefault((parcelRequire("3cqEM")));
var $cf9d3f3d64706810$var$p = new URLSearchParams(window.location.search).get('gclid');
if ($cf9d3f3d64706810$var$p) localStorage.setItem('easy-expense:gclid', $cf9d3f3d64706810$var$p);
var $cf9d3f3d64706810$var$g = localStorage.getItem('easy-expense:gclid');
if ($cf9d3f3d64706810$var$g) (0, $cf9d3f3d64706810$var$_toConsumableArray2.default)(document.querySelectorAll('a')).filter(function(e) {
    return e.href.includes('app.easy-expense.com');
}).forEach(function(e) {
    var u = new URL(e.href);
    u.searchParams.set('gclid', $cf9d3f3d64706810$var$g);
    e.href = u.toString();
});


//# sourceMappingURL=ee-marketing-site.534d346d.js.map
